import type {
  OnboardingTourStep,
  OnboardingTourStepOption,
  Profile,
  UpdateOnboardingTourStepOptionHandler,
} from 'models';
import { FinishStep } from './finish-step';
import { useInitialStepEffect, useSupportedOnboardingTourStep, useSupportedOnboardingTourSteps } from './hooks';
import { IntroStep } from './intro-step';
import { NoSupportedStep } from './no-supported-step';
import { SupportedStep } from './supported-step';

type P = {
  onChangeStep: UpdateOnboardingTourStepOptionHandler;
  onFinish: () => void;
  onLogout: () => void;
  step?: OnboardingTourStepOption;
  steps: OnboardingTourStep[];
  viewer: Profile;
};

const OnboardingTour = ({ onChangeStep, onFinish, onLogout, step, steps, viewer }: P) => {
  const supportedSteps = useSupportedOnboardingTourSteps({ steps, viewer });
  const supportedStep = useSupportedOnboardingTourStep({ step, steps: supportedSteps });
  useInitialStepEffect({ onChangeStep, step, supportedSteps });

  if (step === undefined) {
    return null;
  }

  if (step === 'intro') {
    return <IntroStep onChangeStep={onChangeStep} onLogout={onLogout} steps={supportedSteps} viewer={viewer} />;
  }

  if (supportedStep) {
    return <SupportedStep onChangeStep={onChangeStep} step={supportedStep} steps={supportedSteps} viewer={viewer} />;
  }

  if (step === 'finish') {
    return <FinishStep onFinish={onFinish} viewer={viewer} />;
  }

  return <NoSupportedStep onChangeStep={onChangeStep} />;
};

export default OnboardingTour;
